<template>
  <div>
    <p v-html="$t('otp.inputOTPCode', [sentTo])" class="mb-base"></p>
    <div class="mb-base text-center">
      <div
        ref="otpCont"
        style="display: flex; flex-direction: row; justify-content: center"
        class="mb-3"
      >
        <OtpInput
          ref="otpInput"
          input-classes="otp-input"
          separator="-"
          :num-inputs="digitCount"
          :should-auto-focus="true"
          :is-input-num="true"
          @on-change="handleOnChange"
          @on-complete="handleOnComplete"
        />
      </div>
      <span>{{ $t("otp.notReceived") }}</span>
      <span class="text-primary cursor-pointer" @click="sendOTP()">{{ $t("otp.resendOTP") }}</span>
      <div>
        <small class="text-danger text-sm">{{ apiErrors[0] }}</small>
      </div>
    </div>
  </div>
</template>

<style>
.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}
@media (max-width: 1200px) {
  .otp-input {
    padding: 5px;
    margin: 0px;
    font-size: 15px;
  }
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>

<script>
import OtpInput from "@bachdgvn/vue-otp-input";
import ErrorHandler from "@/helper/error_handler";

export default {
  name: "otp-form-component",
  props: {
    email: {
      type: String,
    },
    phoneNumber: {
      type: String,
    },
    isUser: {
      type: Boolean,
    },
    digitCount: {
      type: Number,
      default: 6,
    },
  },
  computed: {
    sentTo() {
      return this.email || this.phoneNumber;
    },
  },
  data() {
    return {
      digits: [],
      currentDigit: 1,
      number: null,
      apiErrors: [],
    };
  },
  components: {
    OtpInput,
  },
  methods: {
    handleOnComplete(value) {
      this.number = value;
      this.$emit("input", value);
    },
    handleOnChange(value) {
      this.number = value;
      this.$emit("input", value);
    },
    handleClearInput() {
      this.$refs.otpInput.clearInput();
    },
    sendOTP() {
      this.apiErrors = [];

      this.$vs.loading({
        type: "radius",
        text: `${this.$t("otp.sendingOTP")}...`,
      });

      let param = {};
      if (this.email) {
        param.email = this.email;
      } else if (this.phoneNumber) {
        param.phone_number = this.phoneNumber;
      }
      if (this.isUser) {
        param.is_user = this.isUser;
      }

      return new Promise((resolve, reject) => {
        this.$http
          .post(this.$endpoints.user_otp + "/send", param)
          .then((res) => {
            this.$vs.notify({
              color: "success",
              title: "VIAMOVE SYSTEM",
              text: res.data.message,
            });

            resolve(res);
          })
          .catch((err) => {
            this.apiErrors = ErrorHandler.processErrorMessage(err);
            reject(err);
          })
          .finally(() => {
            this.$vs.loading.close();
          });
      });
    },
    verifyOTP() {
      this.apiErrors = [];

      if (this.number == null || this.number == "" || this.number.length != this.digitCount) {
        this.apiErrors = [this.$t("validation.messages.required", ["OTP"])];
        return new Promise((resolve, reject) => {
          reject(false);
        });
      }

      this.$vs.loading({
        type: "radius",
        text: `${this.$t("otp.verifyingOTP")}...`,
      });

      return new Promise((resolve, reject) => {
        this.$http
          .post(this.$endpoints.user_otp + "/verify", {
            otp: this.number,
          })
          .then((res) => {
            const response = res.data.data;
            let obj = {
              transactionID: response.otp_transaction_id,
            };
            this.$emit("verified", obj);
            resolve(obj);
          })
          .catch((err) => {
            this.apiErrors = ErrorHandler.processErrorMessage(err);
            reject(err);
          })
          .finally(() => {
            this.$vs.loading.close();
          });
      });
    },
  },
};
</script>
